import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";

export default function Documents({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const never = "never" as const;
    const [updatedDocuments, setUpdatedDocuments] = useState(
        submission.documents ?? []
    );
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedDocuments(submission.documents ?? []);
    }, [submission]);

    const onSaveClick = useCallback(async () => {
        /* 
        setSaving(true);
        AttorneyService.SaveProfile({ body: request }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    if (resp.data?.length === 1) {
                        onSearchComplete(request, resp.data[0]);
                    } else if (resp.data && resp.data?.length > 1) {
                        //We will need to show the modal to select which case
                        setSearchResults(resp.data ?? []);
                    } else {
                        setErrorMessage(resp.errorMessage ?? "No case found");
                    }
                } else {
                    console.log(resp.errorMessage);
                    setErrorMessage(resp.errorMessage ?? "No case found");
                }
            },
            (error) => {
                setSaving(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
        */
    }, [updatedDocuments]);

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "ID",
                                field: "id",
                                editable: never,
                            },
                            {
                                title: "Filename",
                                field: "filename",
                            },
                            {
                                title: "Document Type",
                                field: "documentType",
                            },
                            {
                                title: "Predicted Type",
                                field: "predictedType",
                            },
                            {
                                title: "Reference Number",
                                field: "referenceNumber",
                            },
                        ]}
                        data={updatedDocuments}
                        title="Documents"
                    />
                </div>
            </div>
        </div>
    );
}
